export default __webpack_public_path__ + "a046fc4d0c2e2aafa01b7cde74f8097e.png";